<div style="background-color: #F5F7F8; height: 100vh; overflow-y: hidden; padding: 10px; padding-top: 20px; width: 100vw;">
    <div style="height: 85vh; overflow-y: scroll;">

        <div style="text-align: center;">
            <img style="width: 22px; height: 22px; position: relative; top: 5px; float: left; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
            <h2 style="text-align: center; display: inline-block;">Връщане на продукт</h2>
        </div>
        <div style=" margin-bottom: 5px; width: 100%; overflow-x: hidden; position: relative; display: grid;">
            <div  style="margin: auto; background-color: white; margin-top: 10px; margin-bottom: 10px;  border-radius: 10px; padding: 10px; height: fit-content;">
                <div class="form-check col-1" style="display: inline-grid; vertical-align: top; place-items: center;">
                    <img style="width: 22px; height: 22px; margin-left: -10px;" src="/assets/images/vouchers/information.svg">
                </div>
                <h4 style="font-weight: bold; display: inline-block; margin-left: 10px;">Как ще получа парите си?</h4>
                <ul>
                    <li>
                        В случай, че плащането е направено с карта, сумата ще бъде преведена обратно по картата.
                    </li>
                    <li>
                        Ако сте платили с Наложен платеж, моля въведете данните на сметката си по-долу.
                    </li>
                </ul>
            </div>
            <div [formGroup]="this.paymentData" class="mb-3">
                <div class="form-control" style="background-color: white; font-size: 12px; color: #ced4da;" *ngIf="this.paymentData.get('iban')?.dirty">IBAN</div>
                <input type="text" [class]="(this.paymentData.get('iban')!.invalid && this.paymentData.get('iban')!.touched) ? 'form-control is-invalid' : 'form-control'" formControlName="iban" placeholder="IBAN" aria-div="Username" aria-describedby="basic-addon1">

                <div class="form-control" style="background-color: white; font-size: 12px; color: #ced4da;" *ngIf="this.paymentData.get('bank')?.dirty">Банка</div>
                <input type="text" class="form-control" formControlName="bank" placeholder="Банка" aria-div="Username" aria-describedby="basic-addon1">

                <div class="form-control" style="background-color: white; font-size: 12px; color: #ced4da;" *ngIf="this.paymentData.get('name')?.dirty">Титуляр на сметката</div>
                <input type="text" class="form-control" formControlName="name" placeholder="Титуляр на сметката" aria-div="Username" aria-describedby="basic-addon1">

            </div>
        </div>
        <div style="position: absolute; bottom: 25px; text-align: center; width: 90%; margin: auto; left: 5%;">
            <button type="button" [disabled]="!this.paymentData.valid" class="btn btn-primary" style="position: relative; bottom: 0px; width: 100%; margin: auto; height: 45px;" (click)="this.return()">Продължи</button>
        </div>
    </div>
</div>
